import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=20af792e&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=20af792e&lang=css"

import exportComponent from "C:\\Users\\t.matsutake\\workspace\\vue_ws\\EISStudio\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20af792e"]])

export default __exports__